import { ExtensionComponentType } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { CheckoutContentComponent } from './components/extension-components/checkout-content/checkout-content.component';
import { CheckoutExtensionsListComponent } from './list/checkout-extensions-list.component';
import { VipProcessComponent } from './components/extension-components/vip-process/vip-process.component';
import { DatePickerComponent } from './components/extension-components/date-picker/date-picker.component';
import { CustomUpsellComponent } from './components/extension-components/custom-upsell/custom-upsell.component';
import { CartControlComponent } from './components/extension-components/cart-control/cart-control.component';
import { CheckoutUpsellComponent } from './components/extension-components/checkout-upsell/checkout-upsell.component';
import { DeliveryCountdownTimerComponent } from './components/extension-components/delivery-countdown-timer/delivery-countdown-timer.component';
import { HooxPayComponent } from './components/extension-components/embedded-offers/hooxpay/hoox-pay.component';
import { GiftNoteComponent } from './components/extension-components/gift-note/gift-note.component';
import { GiftUnlockComponent } from './components/extension-components/gift-unlock/gift-unlock.component';
import { ShippingRatesFilterComponent } from './components/extension-components/shipping-rates-filter/shipping-rates-filter.component';
import { DiscountRejectionCouponComponent } from './components/extension-components/discount-rejection-coupon/discount-rejection-coupon.component';
import { DynamicReviewsComponent } from './components/extension-components/dynamic-reviews/dynamic-reviews.component';
import { ProductUpgradeComponent } from './components/extension-components/product-upgrade/product-upgrade.component';
import { UrgencyBoostComponent } from './components/extension-components/urgency-boost/urgency-boost.component';
import { MultiShipmentComponent } from './components/extension-components/multi-shipment/multi-shipment.component';
import { DynamicExtensionComponent } from './components/extension-components/dynamic-extension/dynamic-extension.component';
import { OrderProtectionComponent } from './components/extension-components/order-protection/order-protection.component';

export const ComponentsMap = {
  [ExtensionComponentType.LIST]: CheckoutExtensionsListComponent,
  [ExtensionComponentType.VIP_PROCESS]: VipProcessComponent,
  [ExtensionComponentType.DATE_PICKER]: DatePickerComponent,
  [ExtensionComponentType.CART_CONTROL]: CartControlComponent,
  [ExtensionComponentType.CUSTOM_UPSELL]: CustomUpsellComponent,
  [ExtensionComponentType.CHECKOUT_CONTENT]: CheckoutContentComponent,
  [ExtensionComponentType.CHECKOUT_UPSELL]: CheckoutUpsellComponent,
  [ExtensionComponentType.GIFT_UNLOCK]: GiftUnlockComponent,
  [ExtensionComponentType.GIFT_NOTE]: GiftNoteComponent,
  [ExtensionComponentType.SHIPPING_RATES_FILTER]: ShippingRatesFilterComponent,
  [ExtensionComponentType.HOOXPAY]: HooxPayComponent,
  [ExtensionComponentType.DELIVERY_COUNTDOWN_TIMER]: DeliveryCountdownTimerComponent,
  [ExtensionComponentType.DISCOUNT_REJECTION_COUPON]: DiscountRejectionCouponComponent,
  [ExtensionComponentType.DYNAMIC_REVIEWS]: DynamicReviewsComponent,
  [ExtensionComponentType.PRODUCT_UPGRADE]: ProductUpgradeComponent,
  [ExtensionComponentType.URGENCY_BOOST]: UrgencyBoostComponent,
  [ExtensionComponentType.MULTI_SHIPMENT]: MultiShipmentComponent,
  [ExtensionComponentType.DYNAMIC_EXTENSION]: DynamicExtensionComponent,
  [ExtensionComponentType.ORDER_PROTECTION]: OrderProtectionComponent,
};

export const TypeToRouteSlugMap: { [value in ExtensionComponentType]?: string } = {
  [ExtensionComponentType.DATE_PICKER]: 'date-picker',
  [ExtensionComponentType.CHECKOUT_UPSELL]: 'upsell',
  [ExtensionComponentType.CUSTOM_UPSELL]: 'custom-upsell',
  [ExtensionComponentType.CART_CONTROL]: 'cart-control',
  [ExtensionComponentType.DELIVERY_COUNTDOWN_TIMER]: 'delivery-countdown-timer',
  [ExtensionComponentType.CHECKOUT_CONTENT]: 'checkout-content',
  [ExtensionComponentType.GIFT_UNLOCK]: 'gift-unlock',
  [ExtensionComponentType.GIFT_NOTE]: 'gift-note',
  [ExtensionComponentType.SHIPPING_RATES_FILTER]: 'shipping-rates-filter',
  [ExtensionComponentType.HOOXPAY]: 'pdq-cash-back',
  [ExtensionComponentType.VIP_PROCESS]: 'vip-process',
  [ExtensionComponentType.DISCOUNT_REJECTION_COUPON]: 'discount-rejection-coupon',
  [ExtensionComponentType.DYNAMIC_REVIEWS]: 'dynamic-reviews',
  [ExtensionComponentType.PRODUCT_UPGRADE]: 'product-upgrade',
  [ExtensionComponentType.URGENCY_BOOST]: 'urgency-boost',
  [ExtensionComponentType.MULTI_SHIPMENT]: 'multi-shipment',
  [ExtensionComponentType.DYNAMIC_EXTENSION]: 'dynamic-extension',
  [ExtensionComponentType.ORDER_PROTECTION]: 'order-protection',
};
export const ExtensionsUsingIdInUrl: string[] = [ExtensionComponentType.DATE_PICKER];
